import { render, staticRenderFns } from "./AccountingBooksAccountsForm.vue?vue&type=template&id=4d2b65b1&"
import script from "./AccountingBooksAccountsForm.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksAccountsForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksAccountsForm.vue?vue&type=style&index=0&id=4d2b65b1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports